import { Fragment, useLayoutEffect, useState } from "react";

export default function NewVenuePlans() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useLayoutEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [plan, setPlans] = useState(0);

  const plansData = [
    {
      planName: "Basic Plan",
      monthlyPrice: 1099,
      annualPrice: 11200,
      features: [
        "2 Default Views",
        "Dashboard Access",
        "1 Staff Member",
        "Special Package Plan Offer Included",
      ],
    },
    {
      planName: "Pro Plan",
      monthlyPrice: 1999,
      annualPrice: 20389,
      features: [
        "2 Default Views",
        "Dashboard Access",
        "WhatsApp Notifications",
        "Easy Slot Booking View",
        "Unlimited Staff Members",
        "Promoted Listing",
        "1 Instagram Reel Collab & Post (1 per quarter)",
        "Special Package Plan Offer Included",
      ],
    },
    {
      planName: "Commission Plan",
      features: [
        "2 Default Views",
        "Dashboard Access",
        "WhatsApp Notifications",
        "Easy Slot Booking View",
        "Unlimited Staff Members",
        "Special Package Plan Offer Included",
      ],
    },
  ];

  return (
    <Fragment>
      {windowWidth > 768 ? (
        <img
          src="/images/PricingPlanBg.svg"
          className="w-100 position-absolute"
        />
      ) : (
        <img
          src="/images/PricingPlanMobileBg.svg"
          className="w-100 position-absolute"
        />
      )}
      {/* <div className="new-plans-banner-bg"/> */}
      <div className="container-lg position-relative Montserrat">
        <h1 className="text-center plans-banner-heading pt-md-5 pt-4 fw-bold">
          More Bookings, Less Hassle - Smart Pricing for Smart Turfs
        </h1>
        <h6 className="text-center text-white fw-400 pt-2 pt-md-0 my-3">
          Manage bookings, payments, and customers with ease
        </h6>
        <div className="d-flex justify-content-center align-items-center fw-400  pb-md-5 pb-3">
          <div
            className="d-flex bg-white rounded-pill my-3 my-md-4"
            style={{ padding: "2px" }}
          >
            <label
              className={`px-4 px-md-5 py-1 py-md-2 cursor-pointer ${
                plan === 0
                  ? "new-plans-bg-color rounded-pill text-white"
                  : "new-plans-color"
              } fw-600`}
              onClick={() => setPlans(0)}
            >
              Monthly
            </label>
            <label
              className={`px-4 px-md-5 py-1 py-md-2 cursor-pointer ${
                plan === 1
                  ? "new-plans-bg-color rounded-pill text-white"
                  : "new-plans-color"
              } fw-600`}
              onClick={() => setPlans(1)}
            >
              Annually
            </label>
          </div>
        </div>
        <div className="row mt-md-4 mt-5">
          {plansData.map((item, index) => (
            <div className="col-md-4 col-12 mb-4 mb-md-0">
              <div className="p-4 new-plan-card-border bg-white">
                <div className="d-flex align-items-center justify-content-between pb-3 new-plans-border-bottom" style={{height: '45px'}}>
                  <label className="new-plans-color fw-semibold">
                    {item.planName}
                  </label>
                  <label className="new-plans-color text-end">
                    <span
                      className={`${index === 2 ? "d-none" : ""} fw-bolder`}
                      style={{ fontSize: "20px" }}
                    >
                      Rs {plan === 0 ? item.monthlyPrice : item.annualPrice}/
                    </span>{" "}
                    <span
                      className={`${index === 2 ? "d-none" : ""} custom-fs-14`}
                    >
                      {plan === 0 ? "Monthly" : "Annually"}
                    </span>{" "}
                  </label>
                </div>
                <ul className="mt-3 list-unstyled px-0">
                  {item.features.map((feature) => (
                    <li className="row w-100 mb-3 mx-0 align-items-center">
                      <img
                        src="/images/PlansDoubleTick.svg"
                        className="col-1 px-0"
                        width={20}
                        height={20}
                      />
                      <label className="ps-2 plans-list-color col-11 px-0 custom-fs-14">
                        {feature}
                      </label>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
        <div className=" plan-list-add-on mt-3 mt-md-5 Montserrat">
          <label className="w-100 py-4 text-center fw-bolder plans-banner-heading">
            Add On
          </label>
          <div className="row pb-3 mx-2 mx-md-0">
            <div className="col-md-4 col-12 px-md-4 px-2 mb-3 mb-md-0">
              <div className="bg-white border-10 d-flex flex-column justify-content-center align-items-center p-4">
                <label className="w-100 text-center text-black fw-semibold">
                  Promoted Listing
                </label>
                <label className="w-100 text-center fw-semibold new-plans-color">
                  Rs 1500/-
                </label>
              </div>
            </div>
            <div className="col-md-4 col-12 px-md-4 px-2 mb-3 mb-md-0">
              <div className="bg-white border-10 d-flex flex-column justify-content-center align-items-center p-4">
                <label className="w-100 text-center text-black fw-semibold">
                  Whitelabel Customized Page
                </label>
                <label className="w-100 text-center fw-semibold new-plans-color">
                  Rs 5000/-
                </label>
              </div>
            </div>
            <div className="col-md-4 col-12 px-md-4 px-2 mb-3 mb-md-0">
              <div className="bg-white border-10 d-flex flex-column justify-content-center align-items-center p-4">
                <label className="w-100 text-center text-black fw-semibold">
                  Organic Promotion on Instagram
                </label>
                <label className="w-100 text-center fw-semibold new-plans-color">
                  Rs 1500/-{" "}
                  <span
                    className="custom-fs-14 fw-normal"
                    style={{ color: "#000000c2" }}
                  >
                    (1 per Quater)
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
